import { OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import * as fromAuth from '../../../auth/reducers';
var DashboardFoldersWrapperComponent = /** @class */ (function () {
    function DashboardFoldersWrapperComponent(_store) {
        this._store = _store;
    }
    DashboardFoldersWrapperComponent.prototype.ngOnInit = function () {
        // Check clinic options to determine which messaging implementation to use
        this.useV3Messaging$ = this._store.pipe(select(fromAuth.getMessagingV3Enabled), map(function (enabled) { return (enabled !== undefined ? enabled : false); }));
    };
    return DashboardFoldersWrapperComponent;
}());
export { DashboardFoldersWrapperComponent };
